/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CandidateEntity } from './candidate-entity';
import { ClientRequestEntity } from './client-request-entity';
import { ContactEntity } from './contact-entity';
export class CalendarManualInterviewRequestEntity extends Entity {
  adhocEmail: string | null = null;
  adhocFirstName: string | null = null;
  adhocLastName: string | null = null;
  availabilityNote: string | null = null;
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  clientRequest: ClientRequestEntity | null = null;
  clientRequestId: string | null = null;
  contact: ContactEntity | null = null;
  contactId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  updatedAt: string | null = null;
  static override key = 'CalendarManualInterviewRequest';
  static override get schema() {
    return {
      candidate: CandidateEntity,
      clientRequest: ClientRequestEntity,
      contact: ContactEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CalendarManualInterviewRequest' in input
    ) {
      const { CalendarManualInterviewRequest: wrapped, ...rest } = input as {
        CalendarManualInterviewRequest: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}